import { IntlProvider, UserProvider } from "capsule"
// eslint-disable-next-line no-duplicate-imports
import * as React from "react"
import { SafeAreaProvider } from "react-native-safe-area-context"

import { transform } from "../models/UserDataFunctions"
import CodeProvider from "./CodeProvider"
import MessageProvider from "./MessageProvider"
import MfaProvider from "./MfaProvider"
import MigrationAccountProvider from "./MigrationAccountProvider"
import ProgramProvider from "./ProgramProvider"
import RoleProvider from "./RoleProvider"

interface IProps {
  children: React.ReactNode
}

const RootProvider: React.FC<IProps> = props => (
  <SafeAreaProvider>
    <UserProvider options={{ transform }} disableToken>
      <IntlProvider>
        <ProgramProvider>
          <RoleProvider>
            <MigrationAccountProvider>
              <CodeProvider>
                <MfaProvider>
                  <MessageProvider>{props.children}</MessageProvider>
                </MfaProvider>
              </CodeProvider>
            </MigrationAccountProvider>
          </RoleProvider>
        </ProgramProvider>
      </IntlProvider>
    </UserProvider>
  </SafeAreaProvider>
)

export default RootProvider
